var elements = document.getElementsByClassName("swatch_title");
      
var updateProduct = function(attribute) {
  console.log('working') 
}

document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#collection-pagination',
      offset: 1000,
      method: 'click'
    });
    collectionSlider()
});

